<template>
  <transition :name="transitionName" @after-leave="$emit('dodestroy')">
    <div
      v-show="visible"
      id="kye-date3-range"
      class="el-picker-panel el-date-range-picker el-popper"
      :class="[
        {
          'start-date': this.activeInputIndex === 0,
          'end-date': this.activeInputIndex === 1,
          'has-sidebar': $slots.sidebar || shortcuts,
          'has-time': showTime
        },
        popperClass
      ]">
      <div
        class="el-picker-panel__body-wrapper"
        :class="{ 'hidden-border-left': !showShortcuts || !shortcuts || !shortcuts.length }">
        <slot name="sidebar" class="el-picker-panel__sidebar"></slot>
        <!-- <div class="el-picker-panel__sidebar" v-if="showShortcuts && shortcuts && shortcuts.length">
          <button
            type="button"
            class="el-picker-panel__shortcut kye-date3-shortcut"
            v-for="(shortcut, key) in showMonthSelect ? monthShortcuts : shortcuts"
            :key="key"
            :class="{
              'is-disabled': typeof shortcut.disabled === 'function' ? shortcut.disabled() : !!shortcut.disabled
            }"
            @click="handleShortcutClick(shortcut)">
            {{ shortcut.text }}
          </button>
        </div> -->
        <ShortcutsWrap
          v-if="showShortcuts"
          :type="type"
          :date="rangeDate"
          :shortcuts="shortcuts"
          :disabledDate="disabledDate"
          :clearable="clearable"
          :showMonthSelect="showMonthSelect"
          :changeShortcutMonth="changeShortcutMonth"
          :handleShortcutMonthClick="handleShortcutMonthClick"
          :handleShortcutClick="handleShortcutClick"
        >
        </ShortcutsWrap>
        <div class="el-picker-panel__body">
          <!-- 头部slot -->
          <component :is="headerSlotRender" />
          <div class="el-date-range-picker__time-header" v-if="showTime">
            <span class="el-date-range-picker__editors-wrap" v-if="showStartInputTimer">
              <span class="el-date-range-picker__time-picker-wrap">
                <el-input
                  style="width: 135px"
                  size="small"
                  ref="minInput"
                  :placeholder="t('el.datepicker.startDate')"
                  class="el-date-range-picker__editor"
                  :value="minVisibleDate"
                  @input.native="handleDateInput($event, 'min')"
                  @change.native="handleDateChange($event, 'min')" />
              </span>
              <span class="el-date-range-picker__time-picker-wrap" v-clickoutside="handleMinTimeClose">
                <el-input
                  style="width: 135px"
                  size="small"
                  :placeholder="t('el.datepicker.startTime')"
                  class="el-date-range-picker__editor"
                  :value="minVisibleTime"
                  @focus="minTimePickerVisible = true"
                  @input="val => handleTimeInput(val, 'min')"
                  @change.native="handleTimeChange($event, 'min')" />
                <time-picker
                  ref="minTimePicker"
                  @pick="handleMinTimePick"
                  :time-arrow-control="arrowControl"
                  :visible="minTimePickerVisible"
                  @mounted="$refs.minTimePicker.format = timeFormat">
                </time-picker>
              </span>
            </span>
            <!-- <span class="el-icon-arrow-right"></span> -->
            <span class="el-date-range-picker__editors-wrap" v-if="showEndInputTimer">
              <span class="el-date-range-picker__time-picker-wrap">
                <el-input
                  size="small"
                  style="width: 135px"
                  :placeholder="t('el.datepicker.endDate')"
                  class="el-date-range-picker__editor"
                  :value="maxVisibleDate"
                  :readonly="!minDate"
                  @input.native="handleDateInput($event, 'max')"
                  @change.native="handleDateChange($event, 'max')" />
              </span>
              <span class="el-date-range-picker__time-picker-wrap" v-clickoutside="handleMaxTimeClose">
                <el-input
                  size="small"
                  style="width: 135px"
                  ref="maxInput"
                  :placeholder="t('el.datepicker.endTime')"
                  class="el-date-range-picker__editor"
                  :value="maxVisibleTime"
                  @focus="minDate && (maxTimePickerVisible = true)"
                  :readonly="!minDate"
                  @input="val => handleTimeInput(val, 'max')"
                  @change.native="handleTimeChange($event, 'max')" />
                <time-picker
                  ref="maxTimePicker"
                  @pick="handleMaxTimePick"
                  :time-arrow-control="arrowControl"
                  :visible="maxTimePickerVisible"
                  @mounted="$refs.maxTimePicker.format = timeFormat">
                </time-picker>
              </span>
            </span>
          </div>
          <div class="el-picker-panel__content el-date-range-picker__content is-left">
            <div class="el-date-range-picker__header">
              <!-- <div class="el-date-range-picker__header_left"> -->
                <button
                  type="button"
                  @click="leftPrevYear"
                  class="el-picker-panel__icon-btn el-icon-d-arrow-left"></button>
                <button
                  type="button"
                  @click="leftPrevMonth"
                  v-show="currentView === 'date'"
                  class="el-picker-panel__icon-btn el-icon-arrow-left"></button>
              <!-- </div> -->
              <!-- <div>{{ activeInputIndex === 0 ? leftLabel : rightLabel }}</div> -->
                <span
                  class="el-date-range-picker__header-label"
                  :class="{ 'active': currentView === 'date' || currentView === 'month' }"
                  @click="showYearPicker"
                >{{ yearLabel }}</span>
                <span
                  v-show="currentView === 'date'"
                  class="el-date-range-picker__header-label active"
                  @click="showMonthPicker"
                >{{ rangeLabel[1] }}</span>
              <!-- </div> -->
              <!-- <div class="el-date-range-picker__header_right"> -->
                <button
                  type="button"
                  @click="rightNextYear"
                  class="el-picker-panel__icon-btn el-icon-d-arrow-right"></button>
                <button
                  type="button"
                  @click="rightNextMonth"
                  v-show="currentView === 'date'"
                  class="el-picker-panel__icon-btn el-icon-arrow-right"></button>
              <!-- </div> -->
            </div>
            <!-- <div class="el-date-range-picker__content" :class="currentView"> -->
            <date-table
              v-show="currentView === 'date'"
              :showLunar="showLunar"
              :singleValue="singleValue"
              :isWeekRange="isWeekRange"
              ref="leftDateTable"
              :showWeekNumber="showWeekNumber"
              :selection-mode="isWeekRange ? 'week' : 'range'"
              :date="rangeDate"
              :default-value="defaultValue"
              :activeInputIndex="activeInputIndex"
              :showTime="showTime"
              :value="value"
              :min-date="minDate"
              :max-date="maxDate"
              :range-state="isWeekRange ? undefined : rangeState"
              :cellPopperContent="cellPopperContent"
              :disabled-date="disabledDate"
              :cell-class-name="cellClassName"
              @changerange="handleChangeRange"
              :first-day-of-week="firstDayOfWeek"
              @pick="handleRangePick">
            </date-table>
            <year-table
              v-show="currentView === 'year'"
              @pick="handleYearPick"
              :value="value"
              :date="rangeDate"
              :min-date="minDate"
              :max-date="maxDate"
              :singleValue="singleValue"
              :activeInputIndex="activeInputIndex">
            </year-table>
            <month-table
              v-show="currentView === 'month'"
              @pick="handleMonthPick"
              :value="value"
              :date="rangeDate"
              :min-date="minDate"
              :max-date="maxDate"
              :singleValue="singleValue"
              :activeInputIndex="activeInputIndex">
            </month-table>
            <!-- </div> -->
          </div>
          <!-- <div class="el-picker-panel__content el-date-range-picker__content is-right"></div> -->
        </div>
      </div>
      <div class="el-picker-panel__footer" v-if="showTime">
        <!-- <el-button v-if="showClear" type="text" size="mini" @click="handleClear">
          {{ t('el.datepicker.clear') }}
        </el-button> -->
        <el-button v-if="showReset" size="mini"  @click="handleReset">重置</el-button>
        <el-button v-if="showConfirm" size="mini" type="primary" :disabled="btnDisabled" @click="handleConfirm(false)">
          {{ t('el.datepicker.confirm') }}
        </el-button>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
import moment from 'moment'
// import { isObject } from 'lodash'
import {
  formatDate,
  parseDate,
  isDate,
  modifyDate,
  modifyTime,
  modifyWithTimeString,
  prevYear,
  nextYear,
  prevMonth,
  nextMonth,
  extractDateFormat,
  extractTimeFormat,
  correctDatesOrder,
  // VALUE_FORMAT,
  FORMAT
} from '../util'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import Locale from 'element-ui/lib/mixins/locale'
import TimePicker from './time'
import DateTable from '../basic/date-table'
import YearTable from '../basic/year-table'
import MonthTable from '../basic/month-table'
import ShortcutsWrap from '../basic/shortcuts-wrap'
import '../style/date-range.scss'

const advanceDate = (date, amount) => {
  return new Date(new Date(date).getTime() + amount)
}

const calcDefaultValue = defaultValue => {
  if (Array.isArray(defaultValue)) {
    return [new Date(defaultValue[0]), new Date(defaultValue[1])]
  } else if (defaultValue) {
    return [new Date(defaultValue), advanceDate(defaultValue, 24 * 60 * 60 * 1000)]
  } else {
    return [new Date(), advanceDate(Date.now(), 24 * 60 * 60 * 1000)]
  }
}

export default {
  mixins: [Locale],

  directives: { Clickoutside },

  computed: {
    showStartInputTimer() {
      // 单边时，需要展示单边的输入框数据
      return !this.showEndInputTimer
    },

    showEndInputTimer() {
      return this.activeInputIndex === 1
    },

    btnDisabled() {
      if (this.singleValue) {
        return false
      }
      // return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]))
      return !(this.minDate || this.maxDate)
    },

    leftLabel() {
      return [this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year'), this.leftDate.getMonth() + 1 + ' ' + '月']
    },

    rightLabel() {
      return [this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year'), this.rightDate.getMonth() + 1 + ' ' + '月']
    },

    leftYear() {
      return this.leftDate.getFullYear()
    },

    leftMonth() {
      return this.leftDate.getMonth()
    },

    leftMonthDate() {
      return this.leftDate.getDate()
    },

    rightYear() {
      return this.rightDate.getFullYear()
    },

    rightMonth() {
      return this.rightDate.getMonth()
    },

    rightMonthDate() {
      return this.rightDate.getDate()
    },

    minVisibleDate() {
      if ((this.singleValue || this.linkPanels) && this.value && this.value.filter(Boolean).length === 1 && this.value[0]) {
        return formatDate(this.value[0], this.dateFormat)
      }
      return this.minDate ? formatDate(this.minDate, this.dateFormat) : ''
    },

    maxVisibleDate() {
      if ((this.singleValue || this.linkPanels) && this.value && this.value.filter(Boolean).length === 1 && this.value[1]) {
        return formatDate(this.value[1], this.dateFormat)
      }
      return this.maxDate ? formatDate(this.maxDate, this.dateFormat) : ''
    },

    minVisibleTime() {
      if (this.timeUserInput.min !== null) return this.timeUserInput.min
      if ((this.singleValue || this.linkPanels) && this.value && this.value.filter(Boolean).length === 1 && this.value[0]) {
        return formatDate(this.value[0], this.timeFormat)
      }
      return this.minDate ? formatDate(this.minDate, this.timeFormat) : ''
    },

    maxVisibleTime() {
      if (this.timeUserInput.max !== null) return this.timeUserInput.max
      if ((this.singleValue || this.linkPanels) && this.value && this.value.filter(Boolean).length === 1 && this.value[1]) {
        return formatDate(this.value[1], this.timeFormat)
      }
      return this.maxDate ? formatDate(this.maxDate, this.timeFormat) : ''
    },

    timeFormat() {
      if (this.format) {
        return extractTimeFormat(this.format)
      } else {
        return 'HH:mm:ss'
      }
    },

    dateFormat() {
      if (this.format) {
        return extractDateFormat(this.format)
      } else {
        return 'yyyy-MM-dd'
      }
    },

    rangeDate() {
      return this.activeInputIndex === 0 ? this.leftDate : this.rightDate
    },

    rangeLabel() {
      return this.activeInputIndex === 0 ? this.leftLabel : this.rightLabel
    },

    yearLabel() {
      const yearTranslation = this.t('el.datepicker.year')
      if (this.currentView === 'year') {
        const year = this.rangeDate.getFullYear()
        const startYear = Math.floor(year / 10) * 10
        if (yearTranslation) {
          return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation
        }
        return startYear + ' - ' + (startYear + 9)
      }
      return this.rangeLabel[0]
    },

    headerSlotRender() {
      if (typeof this.headerSlot === 'function') {
        return {
          render: this.headerSlot
        }
      }
      return {
        render: h => (Array.isArray(this.headerSlot) ? this.headerSlot[0] : null || null)
      }
    }
  },

  data() {
    return {
      popperClass: '',
      value: [],
      defaultValue: null,
      defaultTime: null,
      minDate: '',
      maxDate: '',
      leftDate: new Date(),
      rightDate: nextMonth(new Date()),
      rangeState: {
        hoverDate: null,
        endDate: null,
        selecting: false,
        isPick: false, // 区间，用户是否已操作过
        row: null,
        column: null
      },
      showTime: false,
      shortcuts: '',
      visible: '',
      disabledDate: '',
      firstDayOfWeek: 7,
      minTimePickerVisible: false,
      maxTimePickerVisible: false,
      format: '',
      arrowControl: false,
      cellPopperContent: null,
      leftCellPopperContent: null,
      rightCellPopperContent: null,
      inputTimeType: 'min',
      isWeekRange: false,
      showWeekNumber: false,
      activeInputIndex: 0,
      showLunar: true,
      type: 'daterange',
      currentView: 'date',
      clearable: true,
      beforeShortcutsClick: null,
      shortcutsCallback: null,
      monthShortcutsCallback: null,
      showMonthSelect: false,
      singleValue: false,
      cellClassName: '',
      showShortcuts: true,
      headerSlot: null,
      transitionName: 'el-zoom-in-top',
      showClear: true,
      showReset: true,
      showConfirm: true,
      linkPanels: false,
      timeUserInput: { // 解决类似改24:00到00:00不更新问题
        min: null,
        max: null
      }
    }
  },

  watch: {
    minDate(val) {
      this.timeUserInput.min = null
      this.$nextTick(() => {
        if (this.$refs.maxTimePicker && this.maxDate && this.maxDate < this.minDate) {
          const format = 'HH:mm:ss'
          this.$refs.maxTimePicker.selectableRange = [
            [parseDate(formatDate(this.minDate, format), format), parseDate('23:59:59', format)]
          ]
        }
      })
      if (val && this.$refs.minTimePicker) {
        this.$refs.minTimePicker.date = val
        this.$refs.minTimePicker.value = val
      }
    },

    maxDate(val) {
      this.timeUserInput.max = null
      if (val && this.$refs.maxTimePicker) {
        this.$refs.maxTimePicker.date = val
        this.$refs.maxTimePicker.value = val
      }
    },

    minTimePickerVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.minTimePicker.date = this.minDate || new Date()
          this.$refs.minTimePicker.value = this.minDate || new Date()
          this.$refs.minTimePicker.adjustSpinners()
        })
      }
    },

    maxTimePickerVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.maxTimePicker.date = this.maxDate || new Date()
          this.$refs.maxTimePicker.value = this.maxDate || new Date()
          this.$refs.maxTimePicker.adjustSpinners()
        })
      }
    },

    value(newVal) {
      if (!newVal) {
        this.minDate = null
        this.maxDate = null
      } else if (Array.isArray(newVal)) {
        this.minDate = isDate(newVal[0]) ? new Date(newVal[0]) : null
        this.maxDate = isDate(newVal[1]) ? new Date(newVal[1]) : null
        // 单边时，处理此时左右面板激活的数据
        if (this.singleValue) {
          // 开始时间
          if (this.minDate) {
            // 如果当前选择的与上一次相比 ,都在同一个面板上，则使用之前的，防止跳动
            const inRange = this.dateIsRangeInDateTableRows(this.minDate)
            if (inRange) {
              return
            }
            // 如果不在面板数据内。且最大值又在面板内，则表示。现在的最小值变为了最大值，则判断。最大值是否在当前面板中，且也不能切换面板。
            if (this.maxDate) {
              // 如果当前选择的与上一次相比 ,都在同一个面板上，则使用之前的，防止跳动
              const inRange = this.dateIsRangeInDateTableRows(this.maxDate)
              if (inRange) {
                return
              }
            }
            // 以上都不成立，展示当前的值或者 默认值。
            this.leftDate = this.minDate || calcDefaultValue(this.defaultValue)[0]
          }
          // 结束时间
          if (this.maxDate) {
            // 如果当前选择的与上一次相比 ,都在同一个面板上，则使用之前的，防止跳动
            const inRange = this.dateIsRangeInDateTableRows(this.maxDate)
            if (inRange) {
              return
            }
            this.rightDate = this.maxDate
          } else {
            // 不存在，使用下一个月数据
            this.rightDate = nextMonth(this.leftDate)
          }
          return
        }
        if (this.minDate) {
          // 同时存在保持面板不跳动
          if (this.maxDate) {
            return
          }
          this.leftDate = this.minDate
          this.rightDate = nextMonth(this.leftDate)
        } else {
          this.leftDate = calcDefaultValue(this.defaultValue)[0]
          this.rightDate = nextMonth(this.leftDate)
        }
      }
    },

    defaultValue(val) {
      if (!Array.isArray(this.value)) {
        const [left] = calcDefaultValue(val)
        this.leftDate = left
        this.rightDate = nextMonth(this.leftDate)
      }
    },

    activeInputIndex (newVa, oldVal) {
      this.currentView = 'date'
      if (this.showTime && !this.singleValue) {
        const minDate = this.minDate
        const maxDate = this.maxDate
        if (maxDate && !minDate) {
          this.$emit('pick-hover', maxDate, 1)
        }
        if (minDate && !maxDate) {
          this.$emit('pick-hover', minDate, 0)
        }
      }
    },

    visible() {
      const newVal = this.value || []
      const minDate = isDate(newVal[0]) ? new Date(newVal[0]) : null
      const maxDate = isDate(newVal[1]) ? new Date(newVal[1]) : null
      if (minDate) {
        this.leftDate = minDate
      }
      if (maxDate) {
        this.rightDate = maxDate
      }
      // this.isPanelSelectd = false
      this.rangeState.isPick = false
      // 区间状态纠正（用户如果只点击一次就关闭弹窗）
      this.rangeState.selecting = false
      this.rangeState.hoverDate = null
    }
  },

  methods: {
    showCurrentDatePanelData() {
      const [leftDate, rightDate] = this.value || []
      const minDate = isDate(leftDate) ? new Date(leftDate) : null
      const maxDate = isDate(rightDate) ? new Date(rightDate) : null
      if (this.activeInputIndex === 0 && minDate) {
        this.leftDate = minDate
      }
      if (this.activeInputIndex === 1 && maxDate) {
        this.rightDate = maxDate
      }
    },
    dateIsRangeInDateTableRows(date) {
      if (this.$refs && this.$refs.leftDateTable && this.$refs.leftDateTable.startEndDateRows) {
        const [s, e] = this.$refs.leftDateTable.startEndDateRows()
        if (s && e) {
          const _s = moment(s)
          const _e = moment(e)
          const _date = moment(moment(date).format('YYYY-MM-DD'))
          if (_date.isSameOrAfter(_s) && _date.isSameOrBefore(_e)) {
            return true
          }
        }
      }
    },
    // 清除的逻辑
    handleClearOperation() {
      // 单边时，不走原有的逻辑，走专属的面板逻辑
      if (this.singleValue) {
        this.$emit('single-value-short-pick', { type: 'delete', value: '', activeInputIndex: this.activeInputIndex })
        return
      }
      // 如果清除所有的值，则直接返回空
      this.$emit('pick', [], false)
      // 新增点击快捷面板点击回调
      // const beforeShortcutsClick = this.beforeShortcutsClick
      // if (typeof beforeShortcutsClick === 'function') {
      //   beforeShortcutsClick({ picker, type: 'clear', start: '', end: '' })
      // }
    },
    handleReset() {
      this.$emit('pick', [], true)
    },
    setStartAndEndStyle(picker, { start, end }) {
      if (picker.$children.length) {
        let table = picker.$children.find(com => com.$vnode.componentOptions.tag === 'date-table')
        let _start = FORMAT(start, 'yyyy-MM-dd')
        let _end = FORMAT(end, 'yyyy-MM-dd')
        table.$nextTick(_ => {
          table.$el.querySelectorAll('td').forEach(el => {
            let _row = el.parentNode.rowIndex - 1
            let _column = el.cellIndex
            let _date = FORMAT(table.getDateOfCell(_row, _column), 'yyyy-MM-dd')
            if (_date === _start) {
              el.classList.add('kye-start')
            } else if (_date === _end) {
              el.classList.add('kye-end')
            } else {
              el.classList.remove('kye-start', 'kye-end')
            }
          })
        })
      }
    },
    handleClear() {
      this.minDate = null
      this.maxDate = null
      this.leftDate = calcDefaultValue(this.defaultValue)[0]
      this.rightDate = nextMonth(this.leftDate)
      this.$emit('pick', null)
    },

    handleChangeRange(val) {
      this.minDate = val.minDate
      this.maxDate = val.maxDate
      this.rangeState = val.rangeState
    },

    handleDateInput(event, type) {
      const value = event.target.value
      if (value.length !== this.dateFormat.length) return
      const parsedValue = parseDate(value, this.dateFormat)

      if (parsedValue) {
        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(parsedValue))) {
          return
        }
        if (type === 'min') {
          this.minDate = new Date(parsedValue)
          this.leftDate = new Date(parsedValue)
          this.rightDate = new Date(parsedValue)
        } else {
          this.maxDate = new Date(parsedValue)
          this.leftDate = new Date(parsedValue)
          this.rightDate = new Date(parsedValue)
        }
      }
    },

    handleDateChange(event, type) {
      const value = event.target.value
      const parsedValue = parseDate(value, this.dateFormat)
      if (parsedValue) {
        if (type === 'min') {
          this.minDate = modifyDate(
            this.minDate,
            parsedValue.getFullYear(),
            parsedValue.getMonth(),
            parsedValue.getDate()
          )
          if (this.minDate > this.maxDate) {
            this.maxDate = this.minDate
          }
        } else {
          this.maxDate = modifyDate(
            this.maxDate,
            parsedValue.getFullYear(),
            parsedValue.getMonth(),
            parsedValue.getDate()
          )
          if (this.maxDate < this.minDate) {
            this.minDate = this.maxDate
          }
        }
      }
    },

    handleTimeInput(value, type) {
      this.timeUserInput[type] = value
      if (value.length !== this.timeFormat.length) return
      const parsedValue = parseDate(value, this.timeFormat)
      if (parsedValue) {
        if (type === 'min') {
          this.minDate = modifyTime(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds())
          this.$nextTick(_ => this.$refs.minTimePicker.adjustSpinners())
        } else {
          this.maxDate = modifyTime(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds())
          this.$nextTick(_ => this.$refs.maxTimePicker.adjustSpinners())
        }
      }
    },

    handleTimeChange(event, type) {
      const value = event.target.value
      const parsedValue = parseDate(value, this.timeFormat)
      if (parsedValue) {
        if (type === 'min') {
          this.minDate = modifyTime(
            this.minDate,
            parsedValue.getHours(),
            parsedValue.getMinutes(),
            parsedValue.getSeconds()
          )
          // if (this.minDate > this.maxDate) {
          //   this.maxDate = this.minDate
          // }
          this.$refs.minTimePicker.value = this.minDate
          this.minTimePickerVisible = false
          this.handleTimeConfirm()
        } else {
          this.maxDate = modifyTime(
            this.maxDate,
            parsedValue.getHours(),
            parsedValue.getMinutes(),
            parsedValue.getSeconds()
          )
          // if (this.maxDate < this.minDate) {
          //   this.minDate = this.maxDate
          // }
          this.$refs.maxTimePicker.value = this.minDate
          this.maxTimePickerVisible = false
          this.handleTimeConfirm()
        }
      }
    },
    handleWeekRangePick(val, close = true) {
      const { date } = val
      if (this.minDate && this.maxDate) {
        this.minDate = date
        this.maxDate = null
      } else if (!this.minDate) {
        this.minDate = date
      } else if (this.minDate && !this.maxDate) {
        this.maxDate = date
      }

      this.onPick && this.onPick(val)
      if (!close || this.showTime) return
      this.handleConfirm()
    },

    handleRangePick(val, close = true) {
      if (this.isWeekRange) {
        this.handleWeekRangePick(val, close)
        return
      }
      const { isDateRangePick } = val
      const defaultTime = this.defaultTime || []
      const isTime = this.showTime
      // const preMaxDate = val.preMaxDate
      let minDate = modifyWithTimeString(val.minDate, defaultTime[0])
      let maxDate = modifyWithTimeString(val.maxDate, defaultTime[1])
      const activeInputIndex = this.activeInputIndex

      // 仅首次操作需要当前activeInputIndex对应默认时间
      if (isTime) {
        if (activeInputIndex === 0) {
          maxDate = this.maxDate
        } else {
          minDate = this.minDate
        }
      }

      // 单边时，不走原有的逻辑，防止被阻止
      if (!this.singleValue && this.maxDate === maxDate && this.minDate === minDate) {
        return
      }

      this.onPick && this.onPick(val)
      this.maxDate = maxDate
      this.minDate = minDate

      this.handleDateMouseEnter({
        // 依赖内部交互，单边值只要不是两个值都有的情况下的情况下，只有minDate
        newDate: ((this.singleValue && !maxDate && minDate) || activeInputIndex === 0) ? minDate : maxDate,
        isDateRangePick: !(minDate && maxDate), // 区分是否是悬浮，是否是完整值
      })

      // 防止面板抖动
      this.leftDate = this.rightDate = activeInputIndex === 0 ? this.leftDate : this.rightDate

      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
      setTimeout(() => {
        this.maxDate = maxDate
        this.minDate = minDate
      }, 10)
      // 单边时，不走原有的逻辑，此时需要符合单个的逻辑可通过，且处理异常场景
      if (this.singleValue) {
        const currentVal = (this.value || []).map(v => isDate(v) ? new Date(v) : null)
        let value = [this.minDate, this.maxDate]
        let length = value.filter(Boolean).length
        let visible = length !== 2

        // 单次操作，如果是点击的右侧面板，且不存在结束，maxDate不存在，但是minDate存在（此处是date-table的区间交互刻意为之）
        if (length === 1) {
          visible = true
          if (activeInputIndex === 0) {
            value = [this.minDate, null]
            if (!currentVal[0] && currentVal[1] && this.minDate <= currentVal[1]) {
              value = [this.minDate, currentVal[1]]
              visible = false
            }
          }
          if (activeInputIndex === 1) {
            value = [null, this.minDate]
            if (currentVal[0] && !currentVal[1] && this.minDate >= currentVal[0]) {
              value = [currentVal[0], this.minDate]
            }
          }
        }

        if (length === 2) {
          if (activeInputIndex === 0) {
            visible = true
          }
        }

        this.$emit('single-value-pick', { value, activeInputIndex }, visible)
        return
      }

      // 已有值情况
      if (isDateRangePick) {
        !isTime ? this.handleConfirm(true) : this.handleTimeConfirm()
        return
      }

      if (!close) return

      if (isTime) {
        this.handleTimeConfirm()
        return
      }
      this.handleConfirm()
    },

    handleYearPick(year) {
      this.currentView = 'month'
      this.leftDate = this.rightDate = modifyDate(this.rangeDate, year, 0, 1)
    },

    handleMonthPick(month) {
      this.leftDate = this.rightDate = modifyDate(this.rangeDate, this.rangeDate.getFullYear(), month, 1)
      this.currentView = 'date'
    },

    handleShortcutClick(shortcut) {
      // const disabled = typeof shortcut.disabled === 'function' ? shortcut.disabled() : shortcut.disabled
      // if (disabled) {
      //   return
      // }
      if (shortcut.onClick) {
        shortcut.onClick(this)
      } else if (typeof shortcut.value === 'function') {
        this.shortcutEmit(shortcut.value())
      } else if (shortcut.id === 'monthSelect') {
        this.changeShortcutMonth(true)
      }
    },

    changeShortcutMonth (val) {
      this.showMonthSelect = val
    },

    handleShortcutMonthClick (month) {
      const { value } = month
      this.changeShortcutMonth(false)
      let start = moment(this.rangeDate).month(value - 1).startOf('month').startOf('day').toDate()
      let end = moment(this.rangeDate).month(value - 1).endOf('month').endOf('day').toDate()
      this.shortcutEmit([start, end])
    },

    shortcutEmit (value) {
      const [minDate, maxDate] = value || []
      // 单边时，不走原有的逻辑。走自身的替换逻辑
      if (this.singleValue) {
        this.$emit('single-value-short-pick', {
          type: 'replace',
          value: [minDate, maxDate],
          activeInputIndex: this.activeInputIndex
        })
        return
      }
      this.$emit('pick', [minDate, maxDate], false)
    },


    handleMinTimePick(value, visible, first) {
      // this.minDate = this.minDate || new Date()
      if (this.singleValue && value) {
        let _value = (this.value || []).map(v => isDate(v) ? new Date(v) : null)
        _value[0] = modifyTime(_value[0] || _value[1] || new Date(), value.getHours(), value.getMinutes(), value.getSeconds())
        this.$emit('single-value-pick', { value: _value, activeInputIndex: this.activeInputIndex }, true)
      }

      if (!this.singleValue && value) {
        this.minDate = modifyTime(this.minDate || this.maxDate || new Date(), value.getHours(), value.getMinutes(), value.getSeconds())
        this.handleTimeConfirm()
      }

      if (!first) {
        this.minTimePickerVisible = visible
      }

      // if (!this.maxDate || (this.maxDate && this.maxDate.getTime() < this.minDate.getTime())) {
      //   this.maxDate = new Date(this.minDate)
      // }
    },

    handleMinTimeClose() {
      this.minTimePickerVisible = false
    },

    handleMaxTimePick(value, visible, first) {
      if (this.singleValue && value) {
        let _value = (this.value || []).map(v => isDate(v) ? new Date(v) : null)
        _value[1] = modifyTime(_value[1] || _value[0] || new Date(), value.getHours(), value.getMinutes(), value.getSeconds())
        this.$emit('single-value-pick', { value: _value, activeInputIndex: this.activeInputIndex }, true)
      }

      if (!this.singleValue && value) {
        this.maxDate = modifyTime(this.maxDate || this.minDate || new Date(), value.getHours(), value.getMinutes(), value.getSeconds())
        // this.$emit('pick-hover', this.maxDate, this.activeInputIndex)
        this.handleTimeConfirm()
      }

      if (!first) {
        this.maxTimePickerVisible = visible
      }

      // if (this.maxDate && this.minDate && this.minDate.getTime() > this.maxDate.getTime()) {
      //   this.minDate = new Date(this.maxDate)
      // }
    },

    handleMaxTimeClose() {
      this.maxTimePickerVisible = false
    },

    showMonthPicker() {
      this.currentView = 'month'
    },

    showYearPicker() {
      this.currentView = 'year'
    },

    leftPrevYear() {
      const isLeft = this.activeInputIndex === 0
      if (this.currentView === 'year') {
        if (isLeft) {
          this.leftDate = prevYear(this.rangeDate, 10)
          this.rightDate = nextMonth(this.leftDate)
        } else {
          this.rightDate = prevYear(this.rangeDate, 10)
          this.leftDate = prevMonth(this.rightDate)
        }
      } else {
        if (isLeft) {
          this.leftDate = prevYear(this.rangeDate)
          this.rightDate = nextMonth(this.leftDate)
        } else {
          this.rightDate = prevYear(this.rangeDate)
          this.leftDate = prevMonth(this.rightDate)
        }
      }
    },

    leftPrevMonth() {
      // if (!this.singleValue && !this.linkPanels) {
      //   this.leftDate = prevMonth(this.leftDate)
      //   return
      // }
      if (this.activeInputIndex === 0) {
        this.leftDate = prevMonth(this.rangeDate)
      } else {
        this.rightDate = prevMonth(this.rangeDate)
      }
    },

    rightNextYear() {
      const isLeft = this.activeInputIndex === 0
      if (this.currentView === 'year') {
        if (isLeft) {
          this.leftDate = nextYear(this.rangeDate, 10)
          this.rightDate = nextMonth(this.leftDate)
        } else {
          this.rightDate = nextYear(this.rangeDate, 10)
          this.leftDate = prevMonth(this.rightDate)
        }
      } else {
        if (isLeft) {
          this.leftDate = nextYear(this.rangeDate)
          this.rightDate = nextMonth(this.leftDate)
        } else {
          this.rightDate = nextYear(this.rangeDate)
          this.leftDate = prevMonth(this.rightDate)
        }
      }
    },

    rightNextMonth() {
      // if (!this.singleValue && !this.linkPanels) {
      //   this.leftDate = nextMonth(this.leftDate)
      //   return
      // }

      if (this.activeInputIndex === 0) {
        this.leftDate = nextMonth(this.rangeDate)
      } else {
        this.rightDate = nextMonth(this.rangeDate)
      }
    },

    leftNextYear() {
      this.leftDate = nextYear(this.leftDate)
    },

    leftNextMonth() {
      this.leftDate = nextMonth(this.leftDate)
    },

    rightPrevYear() {
      this.rightDate = prevYear(this.rightDate)
    },

    rightPrevMonth() {
      this.rightDate = prevMonth(this.rightDate)
    },

    handleTimeConfirm (visible = true) {
      const activeInputIndex = this.activeInputIndex
      let val = [this.minDate, this.maxDate]

      if ((this.minDate && !this.maxDate) || (!this.minDate && this.maxDate)) {
        let date = activeInputIndex === 0 ? this.minDate : this.maxDate
        this.$emit('pick-hover', date, activeInputIndex)
        return
      }

      if (this.isValidValue(val)) {
        this.$emit('pick', val, visible)
      }
    },

    handleConfirm(visible = false) {
      let val = [this.minDate, this.maxDate]
      let activeInputIndex = this.activeInputIndex
      if (this.isWeekRange) {
        val = correctDatesOrder(val)
      }

      // 时间类型点击【确认】
      if (this.showTime && ((this.minDate && !this.maxDate) || (!this.minDate && this.maxDate) || (this.activeInputIndex === 0 && this.minDate && this.maxDate && this.rangeState.isPick))) {
        let date = activeInputIndex === 0 ? this.minDate : this.maxDate
        const start = isDate(val[0]) ? val[0] : null
        const end = isDate(val[1]) ? val[1] : null
        const isStartAfterEnd = start && end && start.getTime() > end.getTime()
        let focusIndex = activeInputIndex === 0 ? 1 : 0
        if (isStartAfterEnd) {
          focusIndex = 0
          activeInputIndex = 0
          date = null
          this.minDate = null
        }
        this.rangeState.selecting = true
        this.$emit('pick-hover', date, activeInputIndex, focusIndex)
        return
      }

      // 假操作。仅关闭弹窗
      if (this.singleValue && this.isValidValue(val)) {
        this.$emit('single-value-pick', { value: val }, visible)
        return
      }

      if (this.isValidValue(val)) {
        this.$emit('pick', val, visible)
      }
    },

    isValidValue(value, msg = '选择的时间不可用') {
      const isRange = Array.isArray(value) && value
      const isStart = isRange && value[0] && isDate(value[0])
      const isEnd = isRange && value[1] && isDate(value[1])
      const valid =
        isStart &&
        isEnd &&
        value[0].getTime() <= value[1].getTime()
      let disabledDate = true
      if (typeof this.disabledDate === 'function') {
        disabledDate = !(isStart && this.disabledDate(value[0])) && !(isEnd && this.disabledDate(value[1]))
        if (!disabledDate) {
          this.$message.warning(msg)
        }
      }
      return valid && disabledDate
    },

    resetView() {
      // NOTE: this is a hack to reset {min, max}Date on picker open.
      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
      if (this.singleValue || this.linkPanels) {
        // 触发内部连选逻辑
        setTimeout(() => {
          if (this.value && this.value.filter(Boolean).length === 1) {
            this.minDate = null
            this.maxDate = null
            const minDate = isDate(this.value[0]) ? new Date(this.value[0]) : null
            const maxDate = isDate(this.value[1]) ? new Date(this.value[1]) : null
            minDate && this.$refs.leftDateTable.seStartEndCellClasses(minDate, 'min')
            maxDate && this.$refs.leftDateTable.seStartEndCellClasses(maxDate, 'max')
          }

          if (this.value && this.value.filter(Boolean).length === 2) {
            this.minDate = this.value && isDate(this.value[0]) ? new Date(this.value[0]) : null
            this.maxDate = this.value && isDate(this.value[0]) ? new Date(this.value[1]) : null
          }
        })
      } else {
        this.minDate = this.value && isDate(this.value[0]) ? new Date(this.value[0]) : null
        this.maxDate = this.value && isDate(this.value[0]) ? new Date(this.value[1]) : null
      }

      this.currentView = 'date'
      // this.minDate = this.value && isDate(this.value[0]) ? new Date(this.value[0]) : null
      // 单边时，不走原有的逻辑，防止maxDate被 开始时间限制
      // if (this.singleValue) {
      //   this.maxDate = this.value && isDate(this.value[1]) ? new Date(this.value[1]) : null
      //   return
      // }
      // this.maxDate = this.value && isDate(this.value[0]) ? new Date(this.value[1]) : null
    },
    hiddDatePopper() {
      if (this.$refs.leftDateTable) {
        this.$refs.leftDateTable.hiddDatePopper()
      }
      if (this.$refs.rightDateTable) {
        this.$refs.rightDateTable.hiddDatePopper()
      }
    }
  },

  components: { TimePicker, DateTable, YearTable, MonthTable, ShortcutsWrap }
}
</script>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker3/src/panel/date-range.vue